import { TemplateRef } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { MatDialog } from '@angular/material';
import { FormService } from 'src/app/services/form.service';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { RutValidator } from 'ng2-rut';
import { NgxSpinnerService } from 'ngx-spinner';
import { startWith, map } from 'rxjs/operators';
var CalculistaComponent = /** @class */ (function () {
    function CalculistaComponent(fb, _userService, rutValidator, dialog, spinner) {
        this.fb = fb;
        this._userService = _userService;
        this.rutValidator = rutValidator;
        this.dialog = dialog;
        this.spinner = spinner;
        this.rows = [];
        this.nombreComuna = new FormControl('', [Validators.required]);
        this.options = [];
        this.selectedCal = null;
        this.matcher = new FormService();
        this.rut_arq = this.fb.group({
            rut: ['', [Validators.required, this.rutValidator]]
        });
        if (!JSON.parse(localStorage.getItem("calculistas"))) {
            localStorage.setItem("calculistas", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("calculistas"));
        }
        this.invalidRut = true;
        this.calculista = { rut: '', nombre: '', mail: '', apellido_mat: '', apellido_pat: '',
            direccion: '', direccion_complemento: '', direccion_num: '', comuna: '', fono: '', fax: '', patente: '', recordId: '' };
    }
    CalculistaComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.getComunas();
        this.filteredOptions = this.nombreComuna.valueChanges
            .pipe(startWith(''), map(function (value) { return _this._filter(value); }));
    };
    CalculistaComponent.prototype._filter = function (value) {
        var filterValue = value.toLowerCase();
        return this.options.filter(function (option) { return option.toLowerCase().includes(filterValue); });
    };
    CalculistaComponent.prototype.get_calculista = function (rut) {
        var _this = this;
        this.spinner.show();
        this.cleanData();
        this._userService.getCalculista(rut).subscribe(function (response) {
            if (response.message) {
                _this.calculista.rut = rut ? rut : '';
                _this.spinner.hide();
                _this.dialog.open(_this.openModal);
            }
            else {
                _this.calculista.rut = response.rut ? response.rut : '';
                _this.calculista.nombre = response.nombre ? response.nombre : '';
                _this.calculista.apellido_mat = response.apellido_mat ? response.apellido_mat : '';
                _this.calculista.apellido_pat = response.apellido_pat ? response.apellido_pat : '';
                _this.calculista.direccion = response.direccion ? response.direccion : '';
                _this.calculista.direccion_complemento = response.direccion_complemento ? response.direccion_complemento : '';
                _this.calculista.direccion_num = response.direccion_num ? response.direccion_num : '';
                _this.calculista.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                _this.calculista.comuna = response.comuna ? response.comuna : '';
                _this.calculista.fono = response.fono ? response.fono : '';
                _this.calculista.fax = response.fax ? response.fax : '';
                _this.calculista.mail = response.mail ? response.mail : '';
                _this.calculista.patente = response.patente ? response.patente : '';
                _this.calculista.recordId = response.recordId ? response.recordId : '';
                _this.spinner.hide();
                _this.dialog.open(_this.openModal);
            }
        }, function (error) {
            console.log(error);
        });
    };
    CalculistaComponent.prototype.cleanData = function () {
        this.calculista = { rut: '', nombre: '', mail: '', apellido_mat: '', apellido_pat: '',
            direccion: '', direccion_complemento: '', direccion_num: '', direccion_completa: '', comuna: '', fono: '', fax: '', patente: '', recordId: '' };
        this.rut_arq.reset();
    };
    CalculistaComponent.prototype.update_calculista = function (rut, id) {
        this.get_calculista(rut);
        this.selectedCal = id;
    };
    CalculistaComponent.prototype.savecalculista = function () {
        var _this = this;
        window.scroll(0, 0);
        //elimina la fila si escriben un rut que ya esté ingresado
        for (var x = 0; x < this.rows.length; x++) {
            if (this.calculista.rut == this.rows[x].rut) {
                this.delete_calculista(x);
            }
        }
        //elimina fila cuando la editan
        /*if (this.selectedCal != null) {
            this.delete_calculista(this.selectedCal);
            this.selectedCal = null;
        }*/
        this.spinner.show();
        this._userService.saveCalculista(this.calculista).subscribe(function (response) {
            _this.spinner.hide();
            console.log(response);
            if (response.update || response.save) {
                $("#arq_modal").modal("hide");
                _this.actualRow = localStorage.getItem("calculistas");
                _this.rows = JSON.parse(_this.actualRow);
                _this.rows = _this.rows.concat({
                    rut: _this.calculista.rut,
                    nombre: _this.calculista.nombre,
                    apellido_mat: _this.calculista.apellido_mat,
                    apellido_pat: _this.calculista.apellido_pat,
                    direccion: _this.calculista.direccion,
                    direccion_num: _this.calculista.direccion_num,
                    direccion_complemento: _this.calculista.direccion_complemento,
                    direccion_completa: _this.calculista.direccion_completa,
                    comuna: _this.calculista.comuna,
                    fono: _this.calculista.fono,
                    fax: _this.calculista.fax,
                    mail: _this.calculista.mail,
                    patente: _this.calculista.patente
                });
                localStorage.setItem("calculistas", JSON.stringify(_this.rows));
                _this.calculista = { rut: '', nombre: '', mail: '', apellido_mat: '', apellido_pat: '',
                    direccion: '', direccion_complemento: '', direccion_num: '', direccion_completa: '', comuna: '', fono: '', fax: '', patente: '', recordId: '' };
                _this.rut_arq.reset();
                _this.dialog.closeAll();
            }
        }, function (error) {
            _this.spinner.hide();
            console.log(error);
        });
    };
    CalculistaComponent.prototype.delete_calculista = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("calculistas", JSON.stringify(this.rows));
                this.rows = JSON.parse(localStorage.getItem('calculistas'));
            }
        }
    };
    CalculistaComponent.prototype.getComunas = function () {
        var _this = this;
        this._userService.getComunas().subscribe(function (res) {
            //console.log('res', res);
            for (var i = 0; i < res.length; i++) {
                _this.options.push(res[i].fieldData.COM_Nombre);
            }
            _this.filteredOptions = _this.nombreComuna.valueChanges
                .pipe(startWith(''), map(function (value) { return _this._filter(value); }));
        }, function (error) {
            console.log(error);
        });
    };
    return CalculistaComponent;
}());
export { CalculistaComponent };
